import React from "react";
import { motion } from "framer-motion";

const ads = [
  {
    title: "2024_11_Vivo_FP_RM_Standard_300x250_v7_300x250",
    id: 1547295,
    dimensions: "300x250",
    width: 300,
    height: 250,
    videoSrc:
      "https://dsp.eskimi.com/files/upload/rm/upload/672df1a51ff42/Standard_300x250_v7/assets/vid.mp4",
  },
  {
    title: "2024_11_Vivo_FP_RM_Standard_300x250_v7_300x250",
    id: 1547296,
    dimensions: "300x600",
    width: 300,
    height: 600,
    videoSrc:
      "https://dsp.eskimi.com/files/upload/rm/upload/672df1a55a61b/Standard_300x600_v7/assets/vid.mp4",
  },
  {
    title: "2024_11_Vivo_FP_RM_Standard_300x250_v7_300x250",
    id: 1547297,
    dimensions: "320x480",
    width: 320,
    height: 480,
    videoSrc:
      "https://dsp.eskimi.com/files/upload/rm/upload/672df1a59c773/Standard_320x480_v7/assets/vid.mp4",
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const VivoDetail = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12 mt-16">
      <motion.h3
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-3xl font-bold text-gray-800 text-center mb-12"
      >
        Eskimi DSP 2025_04_Tusker_RM_FP (ID: 236159) <br /> Campaign Preview
      </motion.h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {ads.map((ad, index) => (
          <motion.div
            key={ad.id}
            custom={index}
            initial="hidden"
            animate="visible"
            variants={cardVariants}
            className="bg-white rounded-2xl shadow-md hover:scale-105 hover:shadow-lg transition-transform duration-300 overflow-hidden flex flex-col"
          >
            <div className="w-full h-64 bg-black flex justify-center items-center">
              <video
                src={ad.videoSrc}
                autoPlay
                muted
                loop
                playsInline
                className="w-full h-full object-contain"
              />
            </div>

            <div className="p-4 flex-1 flex flex-col justify-between">
              <h4 className="text-lg font-semibold text-gray-700 mb-2 text-center">
                {ad.title}
              </h4>
              <p className="text-sm text-gray-500 text-center mb-1">
                (ID: {ad.id})
              </p>
              <p className="text-sm text-gray-600 text-center">
                Size: {ad.dimensions}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default VivoDetail;
